export default "__VITE_ASSET__BSuAkqtT__"